export default "__VITE_ASSET__DxZ5N0lU__"